import { fonts, colors } from '../../shared/styles';

export const followButton = {
    cursor: 'pointer',
    lineHeight:'15px',
    letterSpacing: '.7px',
    textTransform: 'uppercase',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    fontFamily: 'ProximaNovaRegular',
    borderRadius:'2px',
    color: colors.white,
    fontSize: '11px',
    backgroundColor: colors.blue
};

export const friendButtons = {
    isFriendButton: {
        ...followButton,
        color: colors.blue,
        border: `1px solid ${colors.blue}`,
        background: colors.white
    },
    notFriendButton: {
        ...followButton,
        color: colors.white,
        background: colors.blue
    },
};

export const unofficialResults = {
    buttonStyle: {
        padding: 12,
        textAlign: 'center',
        border: 'none',
        fontFamily: 'ProximaNovaRegular',
        fontSize: 18,
        borderRadius: 3,
        textTransform: 'normal',
        letterSpacing: 0,
        backgroundColor: colors.blue,
        color: colors.white,
        maxWidth: 180
    },
    editIcon: {
        color: colors.white,
        backgroundColor: colors.blue,
        borderRadius: 2,
        padding: '6px 14px'
    }
};

export const claimResult = {
    onErpButton: (canClick) => ({
        backgroundColor: 'transparent',
        border: 'none',
        color: colors.blue,
        cursor: (canClick) ? 'pointer' : 'default',
        fontSize: 12,
        paddingTop: '12px',
        paddingBottom: '12px'
    }),
    defaultClaim: (canClick, isStickyButton, isDisabled = false, claimed = false) => ({
        width: '100%',
        padding: '9px 15px 9px',
        textAlign: 'center',
        ...fonts.default,
        fontSize: 16,
        color: isDisabled ? colors.greyLine : (claimed ? colors.blue : colors.white),
        borderRadius: 2,
        border: '1px solid '+ (isDisabled ? colors.greyLine : colors.blue),
        backgroundColor: claimed || isDisabled ? colors.white : colors.blue,
        cursor: canClick ? 'pointer' : 'default',
        textTransform: isStickyButton ? 'uppercase' : ''
    })
};

export const commentResult = {
    numOfCommentsWrap: {
        fontSize: 10,
        padding: 3,
        color: colors.textColor
    }
};

export const follow = {
    button: {
        position: 'relative',
        display: 'inline-block',
        border: 'none',
        boxShadow: 'none',
        padding: '9px 30px 7px 45px',
        ...fonts.heavy,
        textAlign: 'center',
        fontSize: 13,
        color: colors.white,
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        backgroundColor: colors.blue,
        borderRadius: 2,
        cursor: 'pointer',
    },
    plusSign: {
        position: 'absolute',
        top: '50%',
        left: 23,
        transform: 'translateY(-50%)',
        display: 'inline-block',
        height: 16,
        width: 16,
    }
};

export const heartThisPage = {
    cheerNumberText: (CheerCount) => ({
        color: CheerCount ?'grey':'transparent',
        fontSize:'11px', marginLeft:3
    })
};

export const removeUnofficialResults = {
    mdDelete: {
        color: colors.blue,
        borderRadius: 2,
        padding: '6px 14px'
    }
};

export const commentOnThisPage = {
    content: {
        display:'flex',
        flexWrap:'wrap',
        alignItems: 'center',
        paddingTop: 20,
        marginBottom: 20,
        borderTop: '1px solid '+ colors.greyLine,
    },
    logo: {
        borderRadius: '50%',
        height: 50,
        width: 50,
        marginRight: 20
    },
    underline: {
        borderBottom: 'none',
        backgroundColor: colors.blue
    },
    textField: {
        flex:1,
        width: '100%',
        height: 55,
        marginTop: 0,
        marginBottom: 0,
        ...fonts.default,
        color: colors.textColor,
    },
    commentStyle: {
        link: {
            display: 'inline-block',
            verticalAlign: 'top',
            color: colors.textColor,
            cursor: 'pointer'
        },
        image: {
            height: 50,
            width: 'auto',
            borderRadius: '50%',
            marginRight: 20
        },
        body: {
            display: 'inline-block',
            width: 'calc(100% - 100px)',
        },
        comment: {
            fontSize: 16
        },
        name: {
            fontFamily: 'ProximaNovaSemiBold',
            color: colors.textColor,
            fontSize: 15,
            paddingRight: 15,
        },
        singleComment: {
            borderTop: '1px solid '+ colors.greyLine,
            padding: '20px 0px'
        },
        mainStyle: {
            fontSize: 12,
            fontFamily: 'ProximaNovaRegular',
            color: colors.grey,
        },
        hart: {
            padding: '0px 10px',
            borderRight: '1px solid '+ colors.greyLine,
            borderLeft: '1px solid '+ colors.greyLine
        }
    },
    commentsStyle: {
        p: {
            fontSize: 12,
            textTransform: 'uppercase',
            marginRight: 40,
            color: colors.textColor,
            marginTop: -17,
            marginLeft: 70,
            fontFamily: 'ProximaNovaBold',
            letterSpacing: 1
        },
        wrap: {
            overflow: 'auto',
            maxHeight: 400
        }
    }
};



/** WEBPACK FOOTER **
 ** ./components/control/styles.js
 **/